import { CustomAction, AlertState } from '../model/state';
import {
  SELECT_ALERT_ROW, SELECT_ALL_ALERTS, FETCH_ALERTS_BY_USER_SUCCESS, INCREMENT_ALERT_PAGE, REINIT_ALERT_PAGE_COUNT,
  SET_CURRENT_ALERT, CLEAR_ALERT, CLEAR_ALERT_SUCCESS, CLEAR_ALERT_ERROR, UPDATE_ALERT_SEARCH,
  CLEAR_BULK_ALERTS_SUCCESS, CLEAR_BULK_ALERTS, CLEAR_BULK_ALERTS_ERROR, UPDATE_ALERT_FILTER,
  FETCH_ALARM_LIST, FETCH_ALARM_LIST_SUCCESS, FETCH_ALARM_LIST_ERROR,
  FETCH_ALERT_EXPORT_CSV_DATA, FETCH_ALERT_EXPORT_CSV_DATA_SUCCESS, CLEAR_ALERT_EXPORT_CSV_DATA, FETCH_ALERT_EXPORT_CSV_DATA_ERROR, CLEAR_CRITICAL_ALERT,
} from 'constants/ActionTypes';
import { AlertPayload } from 'actions'

const initialState: AlertState = {
  list: {
    rows: [],
    total: 0,
    page: 1
  },
  isAllSelected: false,
  search: '',
  totals: {
    all: 0,
    critical: 0,
    warning: 0,
    logs: 0,
  },
  currentAlert: null,
  isSubmittingAction: false,
  filters: {
    locationIds: [],
    alarmNames: [],
    activeOnly: false,
  },
  alarmList: {
    rows: [],
    total: 0,
    page: 1,
    isLoading: false,
  },
  exportCsvData: null,
  fetchingCsvData: false,
};

function alertReducer(state: AlertState | undefined = initialState, action: CustomAction<AlertPayload>) {
  switch (action.type) {

    case FETCH_ALERTS_BY_USER_SUCCESS: {
      const newAlerts = action.payload?.alertList?.alerts || [];

      const rows = action.payload?.alertList?.page === 1 ? newAlerts : [
        ...(state.list.rows || []),
        ...newAlerts,
      ];

      return {
        ...state,
        list: {
          rows,
          total: action.payload?.alertList?.total || 0,
          page: action.payload?.alertList?.page || 1
        },
        isAllSelected: false,
        totals: action.payload?.totals || state.totals,
      }
    }

    case SELECT_ALERT_ROW: {
      const index = state.list.rows?.findIndex(alert => alert.id === action.payload?.alertId);
      if (index === undefined) {
        return { ...state }
      }
      const current = state.list.rows ? state.list.rows[index] : undefined;
      if (current === undefined) {
        return { ...state }
      }
      const newRows = [
        ...state.list.rows?.slice(0, index) || [],
        {
          ...current,
          isSelected: action.payload?.select || false
        },
        ...state.list.rows?.slice(index + 1) || []
      ]
      return {
        ...state,
        list: {
          ...state.list,
          rows: newRows
        }
      };
    }

    case SELECT_ALL_ALERTS: {

      const newRows = state.list.rows?.map(alert => ({
        ...alert,
        isSelected: action.payload?.selectAll || false
      }))

      return {
        ...state,
        isAllSelected: action.payload?.selectAll || false,
        list: {
          ...state.list,
          rows: newRows || [],
        }
      };
    }

    case INCREMENT_ALERT_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: state.list.page + 1,
        }
      }
    }

    case REINIT_ALERT_PAGE_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          page: 1,
        }
      }
    }

    case SET_CURRENT_ALERT: {
      return {
        ...state,
        currentAlert: action.payload?.currentAlert || null,
      }
    }

    case CLEAR_ALERT:
    case CLEAR_CRITICAL_ALERT:
    case CLEAR_BULK_ALERTS: {
      return { ...state, isSubmittingAction: true };
    }

    case CLEAR_ALERT_SUCCESS:
    case CLEAR_BULK_ALERTS_SUCCESS:
    case CLEAR_ALERT_ERROR:
    case CLEAR_BULK_ALERTS_ERROR: {
      return {
        ...state,
        isSubmittingAction: false,
        list: {
          ...state.list,
          page: 1, // reinit page number
        }
      };
    }

    case UPDATE_ALERT_SEARCH: {
      return {
        ...state,
        search: action.payload?.search || '',
      }
    }

    case UPDATE_ALERT_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload?.partialFilters
        }
      }
    }

    case FETCH_ALARM_LIST: {
      return {
        ...state,
        alarmList: {
          ...state?.alarmList,
          isLoading: true,
        }
      }
    }

    case FETCH_ALARM_LIST_SUCCESS: {
      return {
        ...state,
        alarmList: {
          ...state?.alarmList,
          rows: action.payload?.alarmList || [],
          isLoading: false,
        }
      }
    }

    case FETCH_ALARM_LIST_ERROR: {
      return {
        ...state,
        alarmList: {
          ...state?.alarmList,
          isLoading: false,
        }
      }
    }

    case FETCH_ALERT_EXPORT_CSV_DATA_SUCCESS: {
      return {
        ...state,
        exportCsvData: action.payload?.exportCsvData || null,
        fetchingCsvData: false,
      }
    }

    case FETCH_ALERT_EXPORT_CSV_DATA: {
      return {
        ...state,
        fetchingCsvData: true,
      }
    }
    case FETCH_ALERT_EXPORT_CSV_DATA_ERROR: {
      return {
        ...state,
        fetchingCsvData: false,
      }
    }
    case CLEAR_ALERT_EXPORT_CSV_DATA: {
      return {
        ...state,
        exportCsvData: initialState.exportCsvData,
      }
    }

    default:
      return state
  }
}

export default alertReducer;
